import { ModalTokenComponent } from './../../../../../modals/modal-token/modal-token.component';
import { StorageService } from '@wlp/ui-bs-oauth';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NavController, ModalController } from "@ionic/angular";
import { ExtractService } from "@wlp/ui-bs-cashout";
import { UserInfoService } from "@wlp/ui-bs-login";
import { RechargeService } from "@wlp/ui-bs-recharge-phone";
import { UiBsTranslateService } from "@wlp/ui-bs-translate";
import { interval, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { LayoutConfigService } from "src/app/core/layout/services/layout-config.service";
import { LoadingService } from "src/app/core/layout/services/loading.service";
import { ModalAlertComponent } from "src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component";
import { ModalExtractReviewComponent } from "src/app/views/themes/sentinel/modals/modal-extract-review/modal-extract-review.component";



@Component({
  selector: 'app-recharge-resume',
  templateUrl: './recharge-resume.component.html',
  styleUrls: ['./recharge-resume.component.scss']
})
export class RechargeResumeComponent implements OnInit {

  backgroundHeaderLogon: any;
  cardIndex: number = -1;
  userProfile: any;
  objectPayment = { charged: true, codeAuthorization: '', dddPhone: '', historicoId: '', numberPhone: '', operadoraId: '', operationCode: '', operationValue: '', produtoId: '', transactionId: '', uuidAccountPayment: '', uuidWhiteLabel: '', nsu: '' };
  interval: any;
  subscription: any;
  data: any;
  history: any;
  listDataResume: any;

  private readonly OPERATION: string = '905';

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private rechargeService: RechargeService,
    private authService: UserInfoService,
    private router: Router,
    private load: LoadingService,
    private modalController: ModalController,
    private extractService: ExtractService,
    private translate: UiBsTranslateService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.backgroundHeaderLogon = this.layoutConfigService.getConfig('wlTheme.header.background.image');

    if (this.router.getCurrentNavigation().extras.state == undefined) {
      this.navController.navigateRoot(['/app/recharge-phone/phone-number']);
    } else {
      this.data = this.router.getCurrentNavigation().extras.state.data;
      //console.log(this.data, "THIS DATA ON INIT");
      this.loadUser()
      this.prepareResume();
    }
  }


  continue() {
    /*  this.navController.navigateRoot(['/app/recharge-phone/phone-number']); */
    this.token();
  }

  back() {
    this.navController.navigateRoot(['/app/recharge-phone/phone-number']);
  }


  preparePayment() {
    this.storageService.get('historic').then(res => {
      this.history = res;
      if (this.history) {
        this.objectPayment.charged = true;
        this.objectPayment.dddPhone = this.data.ddd;
        this.objectPayment.historicoId = this.history;
        this.objectPayment.numberPhone = this.data.phone;
        this.objectPayment.operadoraId = this.data.operatorId;
        this.objectPayment.operationCode = '';
        this.objectPayment.operationValue = this.data.value.value;
        this.objectPayment.produtoId = this.data.value.id;
        this.objectPayment.transactionId = '';
        this.objectPayment.uuidAccountPayment = this.userProfile.uuidAccount;
        this.objectPayment.uuidWhiteLabel = this.userProfile.uuidWhiteLabel;
        this.objectPayment.nsu = this.data.nsu
      }
    })

    this.interval = interval(45000);
    /* this.subscription = this.interval.subscribe(() => this.loadTokenCode()); */
  }

  private loadUser() {
    try {
      const userDetails = this.authService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        this.preparePayment();
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  sendPayment() {
    try {
      this.load.show()
      this.rechargeService.paymentRecharge(this.objectPayment)
        .subscribe(res => {
          if (!res) {
            this.load.hide()
            this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED'), false);
          } else
            if (!res.isExecuted) {
              this.load.hide()
              this.notification('warning-circle', res.message, false);
            } else {
              this.load.hide()
              this.getTransaction(res.transactionId);
            }
        }, (err) => {
          this.load.hide()
          this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED'), false);
        })
    } catch (error) {
      this.load.hide()
    }
  }

  private async notification(status: string, message: string, confirmation?: boolean) {
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        confirmBtn: 'OK',
        confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });

    return await modalSuccess.present();
  }

  getTransaction(transactionId: string) {
    this.extractService.getTransaction(transactionId).subscribe((res) => {
      this.showExtract(res);
    });

  }
  async showExtract(data: any) {
    const modal = await this.modalController.create({
      component: ModalExtractReviewComponent,
      cssClass: 'extract-review',
      componentProps: {
        confirmationData: data,
      },
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((data) => {
      this.navController.navigateRoot(['/app/payment/detran/consult']);
    });
    return await modal.present();
  }

  prepareResume() {
    this.listDataResume = [
      {
        name: this.translate.applyTranslate('RECHARGE_PHONE.LABELS.NUMBER'),
        value: `(${this.data.ddd}) - ${this.data.phone}`
      },

      {
        name: this.translate.applyTranslate('RECHARGE_PHONE.LABELS.OPERATOR'),
        value: this.data.operatorDescription
      },
    ]
  }

  public async token() {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data['data']) {
        this.objectPayment.codeAuthorization = data.role;
        this.sendPayment();
      }
    });
    return await modalToken.present();
  }
}
